module.exports = __webpack_public_path__ + "img/web_nine_grids_1.cf5a9e6f.jpg";